import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMobileScreenButton,
  faCalculator,
} from "@fortawesome/free-solid-svg-icons";

const TablaHorasTrabajadas = ({ data }) => {
  const [paginaActual, setPaginaActual] = useState(1);
  const itemsPorPagina = 6;

  const totalPaginas = Math.ceil((data?.length || 0) / itemsPorPagina);
  const dataPaginada = data?.slice(
    (paginaActual - 1) * itemsPorPagina,
    paginaActual * itemsPorPagina
  );

  return (
    <div className="panel-horas">
      <table className="tabla-detalle">
        <thead>
          <tr>
            <th>Fecha</th>
            <th>Hora</th>
            <th>Lugar y Puesto</th>
            <th>Ciudad</th>
            <th>Evento</th>
            <th>Fichaje</th>
          </tr>
        </thead>
        <tbody>
          {dataPaginada.map((item, i) => (
            <tr key={i}>
              <td>{item.date || "-"}</td>
              <td>{item.registry || "-"}</td>
              <td>
                {item.nameObjective}
                <br />
                <span style={{ color: "#6C757D", fontSize: "14px" }}>
                  {item.namePlace}
                </span>
              </td>
              <td>{item.cityObjective || "-"}</td>
              <td>
                {item.type === "I" ? (
                  <span className="spanIngreso">Ingreso</span>
                ) : item.type === "E" ? (
                  <span className="spanEgreso">Egreso</span>
                ) : (
                  <span className="spanAusente">Ausente</span>
                )}
              </td>
              <td>
                {item.appRegistry ? (
                  <FontAwesomeIcon
                    icon={faMobileScreenButton}
                    style={{ color: "rgb(42, 154, 182)" }}
                    title="Registrado por App"
                  />
                ) : (
                  <FontAwesomeIcon
                    icon={faCalculator}
                    style={{ color: "rgb(42, 154, 182)" }}
                    title="Registrado por Huellero"
                  />
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* 🔄 Paginador interno */}
      {totalPaginas > 1 && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "1rem",
            marginTop: "1rem",
          }}
        >
          <button
            onClick={() => setPaginaActual((p) => Math.max(p - 1, 1))}
            disabled={paginaActual === 1}
            className="boton-paginador"
          >
            ⬅ Anterior
          </button>
          <span style={{ alignSelf: "center" }}>
            Página {paginaActual} de {totalPaginas}
          </span>
          <button
            onClick={() => setPaginaActual((p) => Math.min(p + 1, totalPaginas))}
            disabled={paginaActual === totalPaginas}
            className="boton-paginador"
          >
            Siguiente ➡
          </button>
        </div>
      )}
    </div>
  );
};

export default TablaHorasTrabajadas;